import { patchData, putData } from '~/utils/service';
import { OnSubmitEvent, Scope } from './types';
import { transformFacilitiesFormToApi } from './utils';

const MSAAS_FACILITIES_ROUTE_NAME = 'msaasListingFacilities';
const JOB_LISTING_FACILITIES_ROUTE_NAME = 'jobListingFacilities';
const MSAAS_STATES_ROUTE_NAME = 'msaasListingStates';
const JOB_LISTING_STATES_ROUTE_NAME = 'jobListingStates';
const JOB_LISTING_ROUTE_NAME = 'jobListing';

const resolveSubmitResults = async (apiCalls: (() => Promise<unknown>)[]) => {
  const results: PromiseFulfilledResult<unknown>[] = [];
  for (const apiCall of apiCalls) {
    results.push({ status: 'fulfilled', value: await apiCall() });
  }
  return results;
};

export const msaasSubmit = async ({ input }: { input: Scope }) => {
  const event = input.event as OnSubmitEvent;
  const apiCalls: (() => Promise<unknown>)[] = [];
  apiCalls.push(() =>
    putData(MSAAS_FACILITIES_ROUTE_NAME, {
      data: event.payload.facilities,
      pathParams: { listingId: input.context.listingId.toString() },
      transformRequest: transformFacilitiesFormToApi,
    })
  );
  if (event.payload.shouldPersistStates) {
    apiCalls.push(() =>
      putData(MSAAS_STATES_ROUTE_NAME, {
        data: { stateCodes: event.payload.states },
        pathParams: { listingId: input.context.listingId.toString() },
      })
    );
  }
  return await resolveSubmitResults(apiCalls);
};

export const jobListingSubmit = async ({ input }: { input: Scope }) => {
  const event = input.event as OnSubmitEvent;
  const apiCalls: (() => Promise<unknown>)[] = [];
  // [MCV-1523] Clearing every facility has to persist the clear. Gating the
  // PATCH on a truthy primary meant the states-only path skipped it entirely,
  // so the API kept the previous id while the PUT below removed every
  // association — leaving the listing pointing at a facility it no longer had.
  const hasFacilities = event.payload.facilities.length > 0;
  if (event.payload.primaryFacility || !hasFacilities) {
    apiCalls.push(() =>
      patchData(JOB_LISTING_ROUTE_NAME, {
        data: {
          primaryEmployerFacilityId: hasFacilities ? event.payload.primaryFacility : null,
        },
        pathParams: { id: input.context.listingId.toString() },
      })
    );
  }
  apiCalls.push(() =>
    putData(JOB_LISTING_FACILITIES_ROUTE_NAME, {
      data: event.payload.facilities,
      pathParams: { listingId: input.context.listingId.toString() },
      transformRequest: transformFacilitiesFormToApi,
    })
  );
  if (event.payload.shouldPersistStates) {
    apiCalls.push(() =>
      putData(JOB_LISTING_STATES_ROUTE_NAME, {
        data: { stateCodes: event.payload.states },
        pathParams: { listingId: input.context.listingId.toString() },
      })
    );
  }
  return await resolveSubmitResults(apiCalls);
};
